import type { MediaKind } from 'mediasoup-client/lib/RtpParameters';
import type { RtpEncodingParameters } from 'mediasoup-client/lib/types';
import type { ProducerData, TrackLabel, TrackTransformParams } from '../types/common';

class PeerProducer {
  readonly id: string;

  readonly kind: MediaKind;

  readonly peerId: string;

  readonly label: TrackLabel;

  public paused: boolean;

  readonly encodings: RtpEncodingParameters[] = [];

  readonly maxSpatialLayer: number;

  readonly trackTransformParams?: TrackTransformParams;

  #stateChangedAt: number;

  constructor(params: ProducerData) {
    const {
      id, kind, peerId, label, paused,
    } = params;

    this.id = id;
    this.kind = kind;
    this.peerId = peerId;
    this.label = label;
    this.paused = paused;
    this.encodings = params.encodings;
    this.trackTransformParams = params.trackTransformParams;
    this.maxSpatialLayer = params.maxSpatialLayer;
    this.#stateChangedAt = Date.now();
  }

  setPaused(paused: boolean): void {
    this.paused = paused;
    this.#stateChangedAt = Date.now();
  }

  getStateChangedAt(): number {
    return this.#stateChangedAt;
  }
}

export default PeerProducer;
